import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isMobile } from "react-device-detect";
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import ButtonBase from '@mui/material/ButtonBase';
import { verifyEmail } from 'actions/users.action';

const Img = styled('img')({
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
});

const EmailVarification = (props) => {
    const dispatch = useDispatch();
    const { emailVarified }  = useSelector(({ users_r }) => users_r);
    const { alertMessage } = useSelector(({ general }) => general);
    const { token } = props.match.params;

    useEffect(() => {
        dispatch(verifyEmail(token));
    }, []);

    useEffect(() => {
        if (emailVarified && isMobile) {
            window.location.replace("https://app.odoc.life/tpa/email_verification");
        }
    }, [emailVarified])

    return (
        <div className="app-login-container d-flex justify-content-center align-items-center">
            {
                <Paper sx={{ p: 8 }}>
                    <Grid container wrap="nowrap" spacing={2} >
                        <Grid item xs>
                            <Grid container spacing={3}>
                                <Grid item xs={3}>
                                    <ButtonBase sx={{ width: '40%', marginBottom: 2 }}>
                                        <Img 
                                            alt="complex" 
                                            src={
                                                require("assets/images/" + (
                                                    emailVarified ? "verify-success.svg" : "error.png"
                                                ))
                                            }
                                        />
                                    </ButtonBase>
                                </Grid>
                                <Grid item xs={9}/>
                            </Grid>
                            {
                                emailVarified ?
                                    <div>
                                        <Typography gutterBottom variant="h4" component="div">
                                            <b>You have successfully verified your email.</b>
                                        </Typography>
                                        <Typography variant="h6" color="text.secondary">
                                            Please return to the oDoc app and click the 'I have verified my email' button to continue.
                                        </Typography>
                                    </div> :
                                    <Typography gutterBottom variant="h4" component="div">
                                        <b>{alertMessage}</b>
                                    </Typography>
                            }
                        </Grid>
                    </Grid>
                </Paper>    
            }
        </div>
  );
};

export default withRouter(EmailVarification);
